<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Category
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
                @input="form.name = form.name.toUpperCase()"
              >
                <template v-slot:label>Category Name <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Category
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryEditPage",
  data() {
    return {
      form: {
        name: "",
        subcategories: [],
      },
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
  },
  beforeDestroy() {
    this.$store.dispatch("errors/setErrors", {});
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const subcategoryId = this.$route.params.subcategoryId;
      try {
        const response = await axios.get(`/categories/${subcategoryId}`);
        this.form = response.data.data;
      } catch (error) {
        console.error("Error fetching subcategory data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async save() {
      this.isLoading = true;
      this.$store.dispatch("errors/setErrors", {});
      const subcategoryId = this.$route.params.subcategoryId;
      const categoryId = this.$route.params.categoryId;
      try {
        await axios.patch(`/categories/${subcategoryId}`, this.form);
        this.$router.push(`/categories/${categoryId}/sub-categories`);
      } catch (error) {
        console.error("Error updating category:", error);
        if (error.response && error.response.data && error.response.data.errors) {
          this.$store.dispatch("errors/setErrors", error.response.data.errors);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  padding: 20px;
}
</style>
